export function choicesFromEnum(anyEnum: Record<string, string>
): { id: string, name: string }[] {
  return Object.values(anyEnum).map((value) => {
    return {
      id: value,
      name: value,
    }
  })
}